<template>
    <div class="create-page" @scroll.stop>
        <div style="position: relative;">
            <img class="modal-bg" src="@/assets/img/9-years/award-record-bg.png" alt="">
            <img class="modal-close" @click="closeModal" src="@/assets/img/9-years/modal-close.png" alt="">
            <div class="record">
                <div v-if="myListLoading" class="list-empty-text">加载中..</div>
                <div v-if="!myListLoading && myList.length < 1" class="list-empty-text">暂无数据</div>
                <div class="list">
                    <div class="list-item" v-for="(item, key) in myList" :key="'item-' + key">
                        <div><span class="label">获取时间：</span>{{ item.addtime }}</div>
                        <div @click="handleCpy(item.code)"><span class="label">兑换码：</span>{{ item.code }}<span
                                style="color: #777;">(点击复制)</span></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { Toast } from 'vant';
export default {
    name: 'AwardRecordModal',
    props: {
    },
    data() {
        return {
            myList: [],
            myListLoading: false
        }
    },
    created() {
        document.body.style.overflow = 'hidden';
        this.getList()
    },
    mounted() {

    },
    methods: {
        handleCpy(code) {
            // var inp = document.createElement('input');
            // document.body.appendChild(inp)
            // inp.value = code
            // inp.select();
            // document.execCommand('copy', false);
            // inp.remove();
            // Toast("复制成功~")
            this.$copyText(code).then(function () {
                Toast("复制成功~")
            }, function (e) {
                // alert('Can not copy')
                Toast('复制失败')
                console.log(e)
            })

        },
        closeModal() {
            document.body.style.overflow = '';
            this.$emit("closed")
        },
        getList() {
            if (parent.getAnimalPrizeList) {
                this.myListLoading = true;
                parent.getAnimalPrizeList().done((res) => {
                    this.myList = res
                    this.myListLoading = false;
                })
            }
        }
    }
}
</script>
<style scoped>
.list {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    color: #7b6dc4;
}

.list-item {
    position: relative;
    overflow: hidden;
    text-align: left;
    padding: 10px;
    line-height: 1.6;
    border-bottom: 1px dashed;
    margin-bottom: 10px;
    margin-top: 10px;
}

.list-item .label {
    display: inline-block;
    width: 1.3rem;
    text-align: right;
    ;
}

.record {
    position: absolute;
    top: 19%;
    left: 50%;
    transform: translateX(-50%);
    width: 70%;
    height: 70%;
    text-align: center;
    overflow-y: scroll;
}

.create-page {
    position: fixed;
    width: 100vw;
    height: 100vh;
    max-width: 900px;
    left: 50%;
    transform: translateX(-50%);
    top: 0px;
    z-index: 10;
    overflow-y: scroll;
    background-color: rgba(0, 0, 0, 0.65);
}

.modal-bg {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
}

.modal-close {
    width: 6%;
    position: absolute;
    right: 10px;
    top: 20px;
}

.save-image {
    width: 47.78%;
    position: absolute;
    right: 26.11%;
    bottom: 0%;
}

.konvaStage {
    position: absolute;
    top: 13.5%;
}

.shape-list {
    width: 90%;
    left: 5%;
    position: absolute;
    bottom: 15%;
}

.shape-scroll-list {
    width: 100%;
    position: absolute;
    height: 100%;
    top: 0%;
    display: flex;
    overflow: scroll;
}

.game-shape-item {
    width: 15%;
    height: auto;
    margin: 1.5%;
}
</style>>